var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget_wizard"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:{ active: index + 1 == _vm.active }},[_c('div',{staticClass:"tab-title",on:{"click":function($event){return _vm.onClick(item, index)}}},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }